@if (breakdownInfo) {
  <ion-content scroll-y="false">
    <ion-grid>
      <ion-row class="sis-header">
        <ion-col>
          <ion-img [src]="logoUrl" class="sis-tenant-logo"></ion-img>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="ion-text-center">
          <div>
            <h3><span translate>breakdownInfo.cablewayServices</span></h3>
          </div>
        </ion-col>
      </ion-row>
      <ion-row class="sis-breakdowninfo-name">
        <ion-col>
          <ion-img [src]="breakdownInfoIconUrl" class="sis-breakdowninfo-icon"></ion-img
            ><span>{{ breakdownInfo.name }}</span>
          </ion-col>
        </ion-row>
        <ion-row class="sis-title" [ngStyle]="{ 'background-color': breakdownInfo.color }">
          <ion-col> {{ title }} </ion-col>
        </ion-row>
        <ion-row class="sis-text" [ngStyle]="{ 'background-color': breakdownInfo.color + '66' }">
          <ion-col> {{ text }} </ion-col>
        </ion-row>
        <ion-row style="flex-grow: 1"></ion-row>
        <ion-row class="sis-footer">
          <ion-col>
            <span translate>breakdownInfo.information</span><br />
            <a href="{{ breakdownInfo.homepageUrl }}" target="_blank">{{ homepage }}</a><br />
            <a href="tel:{{ breakdownInfo.telNumber }}">Tel. {{ breakdownInfo.telNumber }}</a>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  }
